import { FilterIcon } from "@heroicons/react/outline";
import React, { useState } from "react";
import { useAuthentication } from "../../context/authentication";
import { Entity } from "../../utils/constants";
import { Label } from "../../utils/types";
import { LabelFilterKey } from "../../utils/useFilteredLabels";
import CloseIcon from "../icons/CloseIcon";
import DisplayLabels from "./DisplayLabels";
import SelectFilteredLabels from "./SelectFilteredLabels";

interface Props {
  className?: string;
  entity: Entity;
  filteredLabels: Label[];
  withWalletLabels?: boolean;
  smartLabels: Label[];
  filterKey: LabelFilterKey;
}

const FilterLabels: React.FC<Props> = ({
  className,
  entity,
  filteredLabels,
  withWalletLabels = false,
  smartLabels = [],
  filterKey
}) => {
  const [showSelectLabels, setShowSelectlabels] = useState(false);
  const { wrapActionWithAuth } = useAuthentication();

  const toggleSelectLabels = wrapActionWithAuth(() => {
    setShowSelectlabels((prevShowSelectLabels) => !prevShowSelectLabels);
  });

  return (
    <div className={className}>
      {showSelectLabels ? (
        <div className="flex-1 flex space-x-2 space-y-0 items-center">
          <SelectFilteredLabels
            entity={entity}
            selectedLabels={filteredLabels}
            onClose={toggleSelectLabels}
            withWalletLabels={withWalletLabels}
            smartLabels={smartLabels}
            filterKey={filterKey}
          />
          <button
            type="button"
            onClick={toggleSelectLabels}
            style={{ margin: "0 0 3px 10px" }}
            className="inline-flex justify-center p-2 text-sm font-medium rounded-md text-gray-700 hover:bg-gray-100 dark:text-white dark:hover:text-gray-800"
          >
            <CloseIcon className="h-5 w-5" />
          </button>
        </div>
      ) : (
        <DisplayLabels
          labels={filteredLabels}
          toggleEditing={toggleSelectLabels}
          addButtonText="Filter"
          editButtonText="Filter"
          addButtonIcon={FilterIcon}
          editButtonIcon={FilterIcon}
          filterKey={filterKey}
        />
      )}
    </div>
  );
};

export default FilterLabels;
